import { Helmet } from "react-helmet";
import { config } from "../../config";
import { useWhiteLabel } from "../../context/WhiteLabelContext";

const MetaTags = ({
    title,
    description,
    keywords,
    ogImage = "https://zoobbe-public.s3.ap-southeast-1.amazonaws.com/zoobbe.svg",
    ogUrl,
}) => {
    const { isWhiteLabel, getAppName, rawBranding } = useWhiteLabel?.() || {};

    // Derive white-label aware defaults
    const wlSeo = rawBranding?.seo || {};
    const wlTitleBase = wlSeo.title || rawBranding?.seoTitle || getAppName?.();
    const wlDescription = wlSeo.description || rawBranding?.seoDescription;
    const wlKeywords =
        keywords ||
        wlSeo.keywords ||
        rawBranding?.seoKeywords ||
        (Array.isArray(wlSeo.tags) ? wlSeo.tags.join(", ") : wlSeo.tags);

    const finalTitle = title || (isWhiteLabel?.() ? (wlTitleBase || "Zoobbe - Plan. Collaborate. Grow.") : "Zoobbe - Plan. Collaborate. Grow.");
    const finalDescription = description || (isWhiteLabel?.() ? (wlDescription || "Zoobbe helps teams and individuals stay organized and on track. Plan, track, and collaborate seamlessly with Zoobbe Board.") : "Zoobbe helps teams and individuals stay organized and on track. Plan, track, and collaborate seamlessly with Zoobbe Board.");
    const finalOgUrl = ogUrl || (typeof window !== 'undefined' ? window.location.href : config.DOMAIN);

    return (
        <Helmet>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            {wlKeywords && <meta name="keywords" content={wlKeywords} />}

            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:url" content={finalOgUrl} />
            <meta property="og:type" content="website" />

            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={ogImage} />
            <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
    );
};

export default MetaTags;
